<template>
  <div>
    <div
      id="aboutModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              About the Urban Dynamic Model
            </h4>
          </div>
          <div class="modal-body">
            <p>
              The Urban Dynamic Model is a full-scale simulation of how
              transport interacts with population, the economy and land use. It
              has been widely used in the UK to test strategies for regeneration
              and to develop integrated land-use and transport investment
              policies.
            </p>
            <p>
              This online demonstration uses a complete version of the model,
              but to provide a simple interface with quick run times it has
              relatively few zones (23) and a more limited range of policy
              variables than the full model provides.
              <br>
              The model has the potential to be applied anywhere – there is
              nothing specifically ‘UK’ about it. It can be scaled, ranging from
              large, detailed implementations with hundreds of zones, down to
              the smaller fast-running version shown here.
            </p>
            <p>
              If you would like to know how the Urban Dynamic Model could help
              your town, city or region, please get in touch via the contact
              form,
              <a
                href=""
                @click.prevent="displayContactModal"
              >here</a>.
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as $ from "jquery";
import "bootstrap";
export default {
  created() {
    this.$root.$data.eventHub.$on("show-about-modal", this.displayModal);
  },
  methods: {
    displayModal: function() {
      $("#aboutModal").modal("show");
    },
    displayContactModal: function() {
      this.$root.$data.eventHub.$emit("show-contact-modal");
    }
  }
};
</script>
